<template>
  <ul class="list-nome space-y-2">
    <li v-for="(role, i) in modelValue" :key="role.id">
      <KnownBusinessEntityContactRole
        v-model="modelValue[i]"
        :disabled="$attrs.disabled"
        :known-business-entity-contact="knownBusinessEntityContact"
        @role-changed="$emit('roleChanged', $event)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Role } from "@/models/role/role.model"
import KnownBusinessEntityContactRole from "@/components/known_business_entity_contact/KnownBusinessEntityContactRole.vue"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"

const modelValue = defineModel<Role[]>({ required: true })

defineProps({
  knownBusinessEntityContact: {
    type: Object as () => KnownBusinessEntityContact,
    required: true
  }
})

defineEmits(["roleChanged"])
</script>

<style scoped></style>
